/** SessionStorage key for one-shot labor messages when leaving Configuration work (same pattern as Pre-Pack). */
export const CONFIGURATION_LABOR_FLASH_STORAGE_KEY = "configuration_labor_flash_message";
